import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { RichDropdownComponent } from '../rich-dropdown';
import { CheckboxOption } from '../../models';
import { RxCheckboxesModule } from '../checkboxes/checkboxes.module';
import { RxButtonModule } from '../button/button.module';
import { deepArrayClone } from '@rx-applications/shared/utils';
import { IconSvgComponent } from '../icon/icon.component';
import { Placement } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-checkboxes-dropdown',
  templateUrl: './checkboxes-dropdown.component.html',
  styleUrls: ['./checkboxes-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RichDropdownComponent, RxCheckboxesModule, RxButtonModule, IconSvgComponent],
})
export class CheckboxesDropdownComponent implements OnInit {
  @ViewChild(RichDropdownComponent, { static: true })
  private richDropdown: RichDropdownComponent;
  private _checkboxes: CheckboxOption[] = [];

  @Input() compact = false;
  @Input() extraCompact = false;
  @Input() showDropdownHeader = true;
  @Input() placeHolder = 'Columns';
  @Input() icon: string | null = null;
  @Input() title: string | null = null;
  @Input() cancelText = 'Cancel';
  @Input() applyText = 'Apply';
  @Input() placement: Placement = 'bottom-right';
  @Input()
  set checkboxes(value: CheckboxOption[]) {
    this._checkboxes = value || [];
    this.checkboxesState = deepArrayClone(this._checkboxes);
    this.checkForHighlight();
  }

  get checkboxes(): CheckboxOption[] {
    return this._checkboxes;
  }
  @Output() checkboxesChange: EventEmitter<CheckboxOption[]> = new EventEmitter();

  // The temporary state is needed since the dropdown doesn't destroy its content when is closed
  checkboxesState: CheckboxOption[];

  highlight = false;

  ngOnInit(): void {
    this.checkboxesState = deepArrayClone(this.checkboxes);
    this.checkForHighlight();
  }

  resetCheckboxes() {
    this.checkboxesState = deepArrayClone(this.checkboxes);
  }

  apply() {
    this.checkboxesChange.emit(this.checkboxesState);
    this.checkForHighlight();
    this.closeDropdown();
  }

  closeDropdown() {
    this.richDropdown.dropdown.close();
  }

  checkForHighlight(): void {
    this.highlight = this.checkboxesState.some((checkbox) => checkbox.checked);
  }
}
